import { render } from "./AdminStageLots.vue?vue&type=template&id=1b3473a1&scoped=true&ts=true&lang=pug"
import script from "./AdminStageLots.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminStageLots.vue?vue&type=script&lang=ts&setup=true"

import "./AdminStageLots.vue?vue&type=style&index=0&id=1b3473a1&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b3473a1"]])

export default __exports__